import Zoomable from '../image/zoomable'
import Modal from '../modal'

export default function ImagePreview({ src, onClose, ...zoomableProps }) {
  return (
    <Modal onClose={onClose} className='wrapper'>
      <div className='photoPreview flex alignCenter justifyCenter'>
        <Zoomable src={src} alt='Photo Preview' fullRes {...zoomableProps} />
      </div>

      <style jsx>{`
        .photoPreview {
          height: 70vh;
          max-width: 90vw;
          min-width: 70vw;
          background: rgba(0, 0, 0, 0.1);
          border-radius: 1rem;

          :global(> div),
          :global(> div > div) {
            height: 100%;
          }

          :global(> div > div > img) {
            height: 100%;
            width: auto !important;
          }
        }

        @media (max-width: 1024px) {
          .photoPreview {
            max-height: calc(100vh - 5.5rem);
            height: 100%;
            max-width: 100vw;
            background: none;
            border-radius: 0;

            :global(> div),
            :global(> div > div) {
              height: auto;
              width: 100%;
            }

            :global(> div > div > img) {
              width: 100% !important;
            }
          }
        }
      `}</style>
    </Modal>
  )
}
